import { casesService, activitiesService, rolesService, usersService, resourceTagsService, } from "../services";
import { COMPLAINTS_COMPLAINTS_LOADING, COMPLAINTS_NEW_COMPLAINT_SUBMITTING, COMPLAINTS_COMPLAINT_LOADING, COMPLAINTS_COMPLAINT_UPDATING, loadComplaint as loadComplaintAction, COMPLAINTS_COMPLAINT_ACTIVITES_LOADING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_SUBMITTING, COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGING, COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGED_COMPLETE, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_DOCUMENT_SUBMITTING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_TRANSFER_SUBMITTING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_LEAD_SUBMITTING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_ASSIGN_SUBMITTING, COMPLAINTS_COMPLAINT_ROLES_LOADING, loadRoles as loadRolesAction, COMPLAINTS_CASE_ROLE_SUBMITTING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLOSE_SUBMITTING, COMPLAINTS_COMPLAINT_ROLES_LOADED, COMPLAINTS_COMPLAINT_ACTIVITES_LOADED, COMPLAINTS_COMPLAINTS_LOADED, COMPLAINTS_API_ERROR, COMPLAINTS_COMPLAINT_LOADED, loadActivities as loadActivitiesAction, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_COMMS_SUBMITTING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_ATTACH_EMAIL_SUBMITTING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_REOPEN_SUBMITTING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLONE_SUBMITTING, COMPLAINTS_COMPLAINT_USER_ROLES_LOADING, COMPLAINTS_COMPLAINT_USER_ROLES_LOADED, COMPLAINTS_CASE_ROLE_DELETING, loadUserRoles as loadUserRolesAction, COMPLAINTS_ACTIVITY_EDIT, COMPLAINTS_ANALYTICS_LOADING, COMPLAINTS_ANALYTICS_LOADED, COMPLAINTS_TEAM_ANALYTICS_LOADED, COMPLAINTS_TEAM_ANALYTICS_LOADING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_SLA_SUBMITTING, COMPLAINTS_NEW_COMPLAINT_ACTIVITY_INTERNAL_MESSAGE_SUBMITTING, } from "./actions";
import { put, call, takeLatest, takeEvery, select, all, getContext } from "redux-saga/effects";
import { selectActivities } from "./selectors";
function* apiError(e) {
    const history = yield getContext("history");
    if (e && e.status && (e.status === 401 || e.status === 403)) {
        return history.push(`/complaints/not-authorized`);
    }
    if (e && e.status && (e.status === 400 || e.status === 404)) {
        return history.push(`/complaints/not-found`);
    }
    else {
        put({
            type: COMPLAINTS_API_ERROR,
            payload: e,
        });
    }
}
function* loadComplaints({ payload }) {
    try {
        const response = yield call([casesService, casesService.getAll], payload);
        yield put({
            type: COMPLAINTS_COMPLAINTS_LOADED,
            payload: response,
        });
    }
    catch (e) {
        yield apiError(e);
    }
}
function* loadComplaint({ payload }) {
    try {
        const { caseId } = payload;
        const { response, roles, resourceTags } = yield all({
            response: call([casesService, casesService.get], caseId),
            roles: call([rolesService, rolesService.getUserActiveRoles], caseId),
            resourceTags: call([resourceTagsService, resourceTagsService.get], caseId),
        });
        response.resourceTags = resourceTags;
        yield put({
            type: COMPLAINTS_COMPLAINT_LOADED,
            payload: { response, roles: { caseId, roles } },
        });
    }
    catch (e) {
        yield apiError(e);
    }
}
function* submitComplaint({ payload }) {
    try {
        const history = yield getContext("history");
        const response = yield call([casesService, casesService.post], payload);
        yield call(() => history.push(`/complaints/${response.id}`));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* updateComplaint({ payload }) {
    const { id, patchDocument, resourceTagsIds } = payload;
    try {
        yield all({
            response: call([casesService, casesService.patch], id, patchDocument),
            tags: call([resourceTagsService, resourceTagsService.post], id, resourceTagsIds),
        });
        yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* loadActivities({ payload }) {
    const { caseId, requestState } = payload;
    const state = yield select(selectActivities);
    const requestingState = Object.assign(Object.assign({}, state.requestedState), requestState);
    try {
        const data = yield call([activitiesService, activitiesService.getAll], caseId, requestingState);
        yield put({
            type: COMPLAINTS_COMPLAINT_ACTIVITES_LOADED,
            payload: {
                data,
                requestState: requestingState,
                caseId,
            },
        });
    }
    catch (e) {
        yield apiError(e);
    }
}
function* submitActivity({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.newCaseNote], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
        yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* submitComms({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.newComms], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* uploadDocument({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.newDocument], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
        //yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* transferCase({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.transferCase], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
        yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* assignCaseLead({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.assignCaseLead], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* assignCase({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.assignCase], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* closeCase({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.closeCase], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
        yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* reopenCase({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.reopenCase], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
        yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* cloneCase({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.cloneCase], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
        yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* attachEmail({ payload }) {
    try {
        const { id, mailId } = payload;
        yield call([activitiesService, activitiesService.attachEmail], id, mailId);
        yield put(loadActivitiesAction(id, { flagged: false }));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* toggleFlagged({ payload }) {
    const { caseId, id } = payload;
    try {
        yield call([activitiesService, activitiesService.toggleFlag], caseId, id);
        yield put({
            type: COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGED_COMPLETE,
            payload: { caseId },
        });
    }
    catch (e) {
        yield apiError(e);
    }
}
function* loadRoles({ payload }) {
    const { caseId } = payload;
    try {
        const data = yield call([rolesService, rolesService.getAll], caseId);
        yield put({
            type: COMPLAINTS_COMPLAINT_ROLES_LOADED,
            payload: {
                data,
            },
        });
    }
    catch (e) {
        yield apiError(e);
    }
}
function* submitRole({ payload }) {
    try {
        const { caseId, model } = payload;
        yield call([rolesService, rolesService.createRole], caseId, model);
        yield put(loadRolesAction(caseId));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* loadUserRoles() {
    try {
        const data = yield call([usersService, usersService.getCaseRoleUsers]);
        yield put({
            type: COMPLAINTS_COMPLAINT_USER_ROLES_LOADED,
            payload: { data },
        });
    }
    catch (e) {
        yield apiError(e);
    }
}
function* deleteCaseRole({ payload }) {
    try {
        const { caseId, caseRoleId } = payload;
        yield call([rolesService, rolesService.removeRole], caseId, caseRoleId);
        yield all([put(loadRolesAction(caseId)), put(loadUserRolesAction())]);
    }
    catch (e) {
        yield apiError(e);
    }
}
function* editActivity({ payload }) {
    try {
        const { caseId, reason, note, meta } = payload;
        yield call([activitiesService, activitiesService.editActivity], caseId, reason, note, meta);
    }
    catch (e) {
        yield apiError(e);
    }
}
function* loadAnalytics({ payload }) {
    try {
        const { params } = payload;
        const response = yield call([casesService, casesService.getAnalytics], params);
        yield put({
            type: COMPLAINTS_ANALYTICS_LOADED,
            payload: response,
        });
    }
    catch (e) {
        yield apiError(e);
    }
}
function* loadTeamAnalytics() {
    try {
        const response = yield call([casesService, casesService.getTeamAnalytics]);
        yield put({
            type: COMPLAINTS_TEAM_ANALYTICS_LOADED,
            payload: response,
        });
    }
    catch (e) {
        yield apiError(e);
    }
}
function* caseSla({ payload }) {
    try {
        const { id, model, isPaused } = payload;
        yield call([
            activitiesService,
            isPaused ? activitiesService.restartCaseSla : activitiesService.pauseCaseSla,
        ], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
        yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
function* internalMessageCase({ payload }) {
    try {
        const { id, model } = payload;
        yield call([activitiesService, activitiesService.internalMessage], id, model);
        yield put(loadActivitiesAction(id, { flagged: false }));
        //yield put(loadComplaintAction(id));
    }
    catch (e) {
        yield apiError(e);
    }
}
export function* complaintsSaga() {
    yield takeLatest(COMPLAINTS_COMPLAINTS_LOADING, loadComplaints);
    yield takeLatest(COMPLAINTS_COMPLAINT_LOADING, loadComplaint);
    yield takeEvery(COMPLAINTS_NEW_COMPLAINT_SUBMITTING, submitComplaint);
    yield takeEvery(COMPLAINTS_COMPLAINT_UPDATING, updateComplaint);
    yield takeLatest(COMPLAINTS_COMPLAINT_ACTIVITES_LOADING, loadActivities);
    yield takeLatest(COMPLAINTS_COMPLAINT_ROLES_LOADING, loadRoles);
    yield takeEvery(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_SUBMITTING, submitActivity);
    yield takeEvery(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_COMMS_SUBMITTING, submitComms);
    yield takeLatest(COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGING, toggleFlagged);
    yield takeLatest(COMPLAINTS_COMPLAINT_ACTIVITES_FLAGGED_COMPLETE, loadActivities);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_DOCUMENT_SUBMITTING, uploadDocument);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_TRANSFER_SUBMITTING, transferCase);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_LEAD_SUBMITTING, assignCaseLead);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_ASSIGN_SUBMITTING, assignCase);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_ATTACH_EMAIL_SUBMITTING, attachEmail);
    yield takeEvery(COMPLAINTS_CASE_ROLE_SUBMITTING, submitRole);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLOSE_SUBMITTING, closeCase);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_REOPEN_SUBMITTING, reopenCase);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_CLONE_SUBMITTING, cloneCase);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_CASE_SLA_SUBMITTING, caseSla);
    yield takeLatest(COMPLAINTS_COMPLAINT_USER_ROLES_LOADING, loadUserRoles);
    yield takeEvery(COMPLAINTS_CASE_ROLE_DELETING, deleteCaseRole);
    yield takeLatest(COMPLAINTS_ACTIVITY_EDIT, editActivity);
    yield takeLatest(COMPLAINTS_ANALYTICS_LOADING, loadAnalytics);
    yield takeLatest(COMPLAINTS_TEAM_ANALYTICS_LOADING, loadTeamAnalytics);
    yield takeLatest(COMPLAINTS_NEW_COMPLAINT_ACTIVITY_INTERNAL_MESSAGE_SUBMITTING, internalMessageCase);
}
